export default {
  curveEditor: {
    saveCurrentCurve: 'Save current curve',
    saveCurve: 'Save the curve',
    curveName: 'Curve name',
    cancel: 'Cancel',
    confirm: 'Sure',
    deleteKeyFrame: 'Delete keyframes',
    auto: 'AUTO',
    freeSmooth: 'FREE_SMOOTH',
    flat: 'FLAT',
    broken: 'BROKEN',
    linear: 'LINEAR',
    close: 'Close',
    save: 'Save',
    dialogProps: {
      title: 'Curve editor',
    },
    curveNameIsEmpty: 'Curve name cannot be empty',
    saveCurveSuccess: 'Save the curve successfully',
  },
  animationCollection: {
    play: 'Play',
    stop: 'Stop',
    save: 'Save',
    close: 'Fold',
    playAllAnimation: 'Play all animation',
    deleteSuccess: 'Delete Successfully',
    stopAnimation: 'Stop all animation',
  },
  animationForm: {
    duration: 'Duration',
    delay: 'Delay',
    style: 'Loop Times',
    playOnAwake: 'Autoplay',
    animationName: 'Name',
    moveAxis: 'Move Axis',
    autoEndTime: 'Auto end time',
    loop: 'Loop',
    distanceX: 'Distance X',
    distanceY: 'Distance Y',
    rebound: 'rebound',
    trialTimes: 'Number of trials',
  },
  qcPoint: {
    setPointValue: 'Set to the current value',
    positionMap: {
      from: 'start point',
      to: 'end point',
    },
    scaleMap: {
      from: 'Start',
      to: 'End',
    },
  },
  animationColor: {
    colorLabel: {
      from: 'start color',
      to: 'end color',
    },
  },
  tweenPosition: {
    show: 'show end position',
    hide: 'hide end position',
  },
  circular: {
    once: 'Play 1 time',
    loop: 'One-way cycle',
    pingPong: 'Two-way loop',
  },
  animationType: {
    base: 'Universal',
    in: 'Approach',
    out: 'Exit',
    strong: 'Emphasize',
  },
  animationTag: [
    'Transparency change',
    'Appear in parallel',
    'In-place zoom appears',
    'Zoom in',
    'Pop up',
    'Expand',
    'Rotate in place',
    'Scroll to appear',
    'Transparency change',
    'Disappear in parallel',
    'In-place zoom appears',
    'Zoom out',
    'Bouncing away',
    'Fold',
    'Rotate in place and disappear',
    'Scroll disappears',
    'Zoom',
    'Flicker',
    'Back and forth',
    'Elasticity',
    'Swing',
    'Rotate',
    'Slide Zoom',
  ],
  tweenLabel: {
    alpha: 'Opacity',
    position: 'Displacement',
    rotation: 'Rotation',
    scale: 'Scale',
    color: 'Color',
  },
  switchAnimation: 'Replace animation',
  scriptManager: {
    animationCurve: 'Curve',
    handArea: 'Interactive Area',
  },
  board: 'Interactive Area',
}
